import api from "../../../services/api";

const APIS = {
  REPORTS_LIST_DATA: "/Reports",
  REPORTS_EXPORT: "/Reports/export",
  REPORTS_DOWNLOAD: "/Sample/lab-analysis-report-pdf",
  REPORTS_RE_NOTIFY: "/Reports/re-notify",
  HISTORICAL_DATA: "/HistoricalData",
  HISTORICAL_DOWNLOAD: "/HistoricalData/historical-report-pdf",
};

export const getReportsListData = async (params) => {
  try {
    const response = await api.get(APIS.REPORTS_LIST_DATA, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching Reports list data:", error);
    throw error;
  }
};
export const getHistoricalData = async (params) => {
  try {
    const response = await api.get(APIS.HISTORICAL_DATA, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching Historical data:", error);
    throw error;
  }
};

export const exportReports = async (params) => {
  try {
    const response = await api.get(APIS.REPORTS_EXPORT, {
      params,
      paramsSerializer: (params) => {
        return Object.keys(params)
          .map((key) =>
            Array.isArray(params[key])
              ? params[key].map((val) => `${key}=${encodeURIComponent(val)}`).join("&")
              : `${key}=${encodeURIComponent(params[key])}`
          )
          .join("&");
      },
      responseType: "blob",
    });
    return response.data;
  } catch (error) {
    console.error("Error exporting Reports data:", error);
    throw error;
  }
};
export const downloadReports = async ({ sampleIds, groupIds }) => {
  try {
    let queryParts = [];
    if (Array.isArray(sampleIds)) {
      sampleIds.forEach((id) =>
        queryParts.push(`sampleIds=${encodeURIComponent(id)}`)
      );
    } else if (sampleIds !== undefined && sampleIds !== null) {
      queryParts.push(`sampleIds=${encodeURIComponent(sampleIds)}`);
    }
    if (Array.isArray(groupIds)) {
      groupIds.forEach((id) =>
        queryParts.push(`groupIds=${encodeURIComponent(id)}`)
      );
    } else if (groupIds !== undefined && groupIds !== null) {
      queryParts.push(`groupIds=${encodeURIComponent(groupIds)}`);
    }
    const url = `${APIS.REPORTS_DOWNLOAD}${
      queryParts.length ? "?" + queryParts.join("&") : ""
    }`;
    const response = await api.get(url, { responseType: "blob" });
    return response.data;
  } catch (error) {
    console.error("Error downloading Reports data:", error);
    throw error;
  }
};
export const reNotifyReports = async (sampleIds) => {
  try {
    const response = await api.post(APIS.REPORTS_RE_NOTIFY, sampleIds, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (error) {
    console.error("Error re-notifying Reports data:", error);
    throw error;
  }
};

export const downloadHistoricalData = async ({ sampleIds, groupIds }) => {
  try {
    let queryParts = [];
    if (Array.isArray(sampleIds)) {
      sampleIds.forEach((id) =>
        queryParts.push(`sampleIds=${encodeURIComponent(id)}`)
      );
    } else if (sampleIds !== undefined && sampleIds !== null) {
      queryParts.push(`sampleIds=${encodeURIComponent(sampleIds)}`);
    }
    if (Array.isArray(groupIds)) {
      groupIds.forEach((id) =>
        queryParts.push(`groupIds=${encodeURIComponent(id)}`)
      );
    } else if (groupIds !== undefined && groupIds !== null) {
      queryParts.push(`groupIds=${encodeURIComponent(groupIds)}`);
    }
    const url = `${APIS.HISTORICAL_DOWNLOAD}${
      queryParts.length ? "?" + queryParts.join("&") : ""
    }`;
    const response = await api.get(url, { responseType: "blob" });
    return response.data;
  } catch (error) {
    console.error("Error downloading Reports data:", error);
    throw error;
  }
};
